import React from 'react';
import { PillarPage } from '../components/marketing/PillarPage';
import { postAcuteCarePlatformConfig } from '../components/marketing/pillarConfigs';

export default function PostAcuteCarePlatformPage() {
  return <PillarPage config={postAcuteCarePlatformConfig} />;
}
